module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Copy address":"Adresse kopieren"}}')
  delete Component.options._Ctor
}
